import type { TMarkImages } from './interfaces'

export const markImages: TMarkImages = ['mercedes', 'toyota', 'landRover', 'bmw', 'volkswagen', 'audi', 'kamaz', 'lada']
